import axios from 'axios';

export const CUSTOM_AXIOS = axios.create();